import React from 'react'
import PropTypes from 'prop-types'

import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'

const Buttons = (props) => {
    return (
        <Grid container spacing={1} direction='row' justifyContent='space-between' alignItems='flex-start'>
            <Grid item>
                <Button
                    variant='outlined'
                    color='error'
                    onClick={props.erase}
                    disabled={props.disabled}
                >
                    格式化
                </Button>
            </Grid>

            <Grid item>
                <Button
                    variant='contained'
                    color='success'
                    onClick={props.program}
                    disabled={props.disabled}
                >
                    烧录
                </Button>
            </Grid>
        </Grid>
    )
}

Buttons.propTypes = {
    erase: PropTypes.func,
    program: PropTypes.func,
    disabled: PropTypes.bool,
}

export default Buttons